<!-- 扩展信息-->
<template>
  <div class="extendedInformation">
    <vxe-table
      border
      resizable
      show-overflow
      :data="tableData"
      size="mini"
      ref="extendedInformation"
      auto-resize
    >
      <vxe-table-column type="index" width="60" :title="$t('goods.table.index')"></vxe-table-column>
      <vxe-table-column
        field="companyName"
        :title="$t('cooperation.extendedTable.company')"
      ></vxe-table-column>
      <vxe-table-column
        field="departmentName"
        :title="$t('cooperation.extendedTable.department')"
      ></vxe-table-column>
      <vxe-table-column
        field="partnerTypeName"
        :title="$t('cooperation.extendedTable.cooperationType')"
      ></vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  export default {
    name: 'extendedInformation',
    props: ['tableData'],
  };
</script>

<style scoped></style>
